import { render, staticRenderFns } from "./Culture.vue?vue&type=template&id=556ff042&scoped=true&"
var script = {}
import style0 from "./Culture.vue?vue&type=style&index=0&id=556ff042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556ff042",
  null
  
)

export default component.exports